var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2,
    transform: "translate(5.5 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.63321199 1.64501818c-.40890855 1.05374695-.63321199 2.19958109-.63321199 3.3978041 0 5.18893492 4.20646285 9.39539772 9.39539775 9.39539772 5.18893485 0 9.39539775-4.2064628 9.39539775-9.39539772 0-1.20053257-.225169-2.34847412-.6355785-3.40389633",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.395398,
    cy: 4.542822,
    r: 4.542822
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.4395154 14.8884675-.0882353 9.3087095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.3953978 20.1215159h-10.00000005"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluto);
export default __webpack_public_path__ + "static/media/pluto.fe582f9c4b478e157a22ce794cd87c66.svg";
export { ForwardRef as ReactComponent };